<template>
    <div>
        <v-dialog v-model="periodicdialog" max-width="800px" @click:outside="closeDetail">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mt-4 mb-3 ml-1" @click="newItem" v-on="on">+</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline mb-4">{{$t('eadtl.addeaformdtl')}}</span>
              <!--<span class="headline mb-4">Periodic Attendance Incentive Input Item</span>-->
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                    <v-col cols="8" sm="6" md="6" class="mt-n8">
                        <v-autocomplete
                            outlined
                            :label="this.$t('columns.coltype')"
                            type="text"
                            dense
                            :items="columnTypeList"
                            v-model="columnType"
                            :rules="[rules.required]"
                            @change="changecolumntype(columnType)"
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="8" sm="6" md="6" class="mt-n8">
                        <v-autocomplete
                            outlined
                            :label="this.$t('columns.col')"
                            type="text"
                            ref="compnyname"
                            dense
                            :items="eaaddondtlList"
                            v-model="selections.col"
                            :rules="[rules.required]"
                            @change="
                                changeEAaddOnHandler(
                                    selections.col
                                )
                            "
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="2" sm="2" md="2" class="mt-n8">
                        <v-text-field
                            outlined
                            background-color="#ffeab2"
                            readonly
                            :label="this.$t('columns.code')"
                            type="text"
                            v-model="selections.col"
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-row v-if="columnType == 1">
                    <v-col cols="10" sm="10" md="10" class="mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('columns.description')"
                            type="text"
                            ref="description"
                            dense
                            v-model="selections.replacement"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="columnType == 2">
                    <v-col cols="10" sm="10" md="10" class="mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('trainingrecord.amount')"
                            type="number"
                            dense
                            v-model="selections.replacement"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row v-if="columnType == 2">
                    <v-col cols="10" sm="10" md="10" class="mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('columns.remark')"
                            type="text"
                            :rules="[rules.required]"
                            dense
                            clearable
                            v-model="selections.remark"
                        ></v-text-field>
                    </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="closeDetail">Cancel</v-btn>
              <v-btn color="green darken-1" text @click="saveDetail">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div style="overflow-x: auto; width: 100%;">
        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            class="elavation-1"
:sort-by="['code']"
        >
        <template v-slot:[`item.action`]="{ item }">
            <v-icon
                small
                class="mr-2"
                @click="modifyItemHandler(item)"
            >
                mdi-pen
            </v-icon>
            <v-icon
                small
                class="ml-3 mr-2"
                @click="deleteItemHandler(item)"
            >
                mdi-delete
            </v-icon>
        </template>

        </v-data-table>
        </div>
    </div>
</template>

<script>
import compareArray from '../../../util/comparearray';

export default {
    props: {
        parentObject: Object
    },

    data() {
        return {

            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                percentage: value => !(value < 0 || value > 100) || this.$t('periodicincentivesetup.valueis')
            },

            
            //    tableOpt: {
            //     itemsPerPage: -1
            // },

            periodicdialog: false,
            detailItem: this.parentObject.detailItem,
            selections: {
                id: null,
                // colid: null,
                col: null,
                coldesc: null,
                replacement: null,
                remark: null,

                rectimestamp: null,
                updatedby: null,
                action:0 ,
                stamp: 0,
            },

            columnType: 1,// set default 1
            columnTypeList: [
                { text: 'Details', value: 1 },
                { text: 'Amount', value: 2 },
            ],

            eaaddondtlList:[],
            eaaddondtlItems: [],

            companyList:[],
            companyItems: [],

            branchList: [],
            branchItems: [],

            itemHolder: [],
            detailList: [],
            factor: false,
            modify: false,
            isExisting: false,
            isErr: false,
            errMsg: ''
        }
    },

 

    methods: {

        compareArray,

newItem() {
    this.isExisting = false;
    this.modify = false;
    this.resetSelections();
},
        async loadEAaddOnList() {
            try {
                const res = await this.$store.dispatch('get', {
                    url: '/eadtlcol'
                });

                this.eaaddondtlItems = res.data.rec;

                // rebuild the list safely
                this.eaaddondtlList = this.eaaddondtlItems.map(item => ({
                    text: item.coldesc,
                    code: item.col,
                    value: item.col
                }));

            } catch (err) {
                this.errMsg = err;
            }
        },

        async changeEAaddOnHandler(id){
            let item = this.eaaddondtlList.find(item => item.code == id);
            
            if(item){ 
                // this.selections.colid = item.id;
                this.selections.coldesc = item.text;
                this.selections.col = item.code;
            }
            else {// since if we switch to different column type, the selected col may not be in the list
                // NOT found → reset
                // this.selections.colid = null;
                this.selections.coldesc = null;
                this.selections.col = null;
            }
        },

        async changecolumntype(id){
            // reset list when column type change,and insert back correct items
            this.eaaddondtlList = []; // reset the list first

            // list of F01 to F23
            const fCodes = [
                'F01','F02','F03','F04','F05','F06','F07','F08','F09','F10',
                'F11','F12','F13','F14','F15','F16','F17','F18','F19','F20',
                'F21','F22','F23'
            ];

            if(id == 1){
                for (let i = 0; i < this.eaaddondtlItems.length; i++) {
                    // NOT in F01 ~ F23
                    if(!fCodes.includes(this.eaaddondtlItems[i].col)){
                        this.eaaddondtlList.push({
                            text: this.eaaddondtlItems[i].coldesc,
                            code: this.eaaddondtlItems[i].col,
                            value: this.eaaddondtlItems[i].col,
                        });
                    }
                }
            }
            else if(id == 2){
                for (let i = 0; i < this.eaaddondtlItems.length; i++) {
                    // IN F01 ~ F23
                    if(fCodes.includes(this.eaaddondtlItems[i].col)){
                        this.eaaddondtlList.push({
                            text: this.eaaddondtlItems[i].coldesc,
                            code: this.eaaddondtlItems[i].col,
                            value: this.eaaddondtlItems[i].col,
                        });
                    }
                }
            }
            else {
                this.isErr = true;
                this.errMsg = "Column type error";
                this.$emit('error', {isErr: this.isErr, errMsg: this.errMsg});
            }
            await this.changeEAaddOnHandler(this.selections.col);
        },

        loadCompany(){
             const vm = this;

            this.$store.dispatch('get', {
                url: '/company/all'
            })
            .then(res => {

                vm.companyItems = res.data.rec;

                for (let i = 0; i < vm.companyItems.length; i++) {
                    vm.companyList.push({
                        text: vm.companyItems[i].compnyname,
                        code: vm.companyItems[i].compnycode,
                        value: vm.companyItems[i].id,
                    });
                }
                
            })
            .catch(err => {
                vm.errMsg = err;
            });

        },

        changeCompanyHandler(id){
            let item = this.companyItems.find(item => item.id == id);

            this.selections.compnycode = item.compnycode;
            this.selections.compnyname = item.compnyname;

        },

        loadBranch(){
             const vm = this;

            this.$store.dispatch('get', {
                url: '/branch/all'
            })
            .then(res => {

                vm.branchItems = res.data.rec;

                for (let i = 0; i < vm.branchItems.length; i++) {
                    vm.branchList.push({
                        text: vm.branchItems[i].brchname,
                        code: vm.branchItems[i].brchcode,
                        value: vm.branchItems[i].id,
                    });
                }
                
            })
            .catch(err => {
                vm.errMsg = err;
            });

        },

        changeBranchHandler(id){
            let item = this.branchItems.find(item => item.id == id);

            this.selections.brchcode = item.brchcode;
            this.selections.brchname = item.brchname;

        },

        async modifyItemHandler(item) {
            // assign loaded data to selections array
            if (item.action) {
                this.isExisting = true;
            } else {
                this.modify = true;
            }

            const fCodes = [
                'F01','F02','F03','F04','F05','F06','F07','F08','F09','F10',
                'F11','F12','F13','F14','F15','F16','F17','F18','F19','F20',
                'F21','F22','F23'
            ];

            this.itemHolder = item
            this.selections =  this.itemHolder;

            if(fCodes.includes(this.selections.col)){
                //is in F01~F23
                this.columnType = 2;
                await this.changecolumntype(this.columnType);
            }
            else{
                // not in F01~F23
                this.columnType = 1;
                await this.changecolumntype(this.columnType);
            }
            //this.selections.userid = this.$store.getters.userId
            this.periodicdialog = true;
        },

        deleteItemHandler(item) {
            let itemIndex = this.detailItem.indexOf(item);

            this.detailItem.splice(itemIndex, 1);

            this.$emit('input', this.detailItem);
        },

        saveDetail() {
            if(this.columnType != 1 && this.columnType != 2){
                this.isErr = true;
                this.errMsg = "Column type error";
                this.$emit('error', {isErr: this.isErr, errMsg: this.errMsg});
                return;
            }
            if(this.selections.col == null || this.selections.col == '' || this.selections.col == undefined || this.selections.col == 0){
                this.isErr = true;
                this.errMsg = "Please select Column";
                this.$emit('error', {isErr: this.isErr, errMsg: this.errMsg});
                return;
            }
            if(this.selections.replacement == null || this.selections.replacement == '' || this.selections.replacement == undefined || this.selections.replacement === 0){
                this.isErr = true;
                this.errMsg = "Please enter Description/Amount";
                this.$emit('error', {isErr: this.isErr, errMsg: this.errMsg});
                return;
            }
            if(this.columnType == 1) {
                this.selections.remark = null; // reset to null for details type
            }

            if (this.columnType == 2) {
                let value = parseFloat(this.selections.replacement);

                // check if it's a valid number
                if (!isNaN(value)) {
                    // round to 2 decimal places while keeping it numeric
                    this.selections.replacement = Math.round(value * 100) / 100;
                    // console.log("this.selections.replacement",this.selections.replacement);
                } else {
                    // handle invalid number (optional)
                    // can also prompt error message or return
                    this.selections.replacement = 0;
                }

                // 16-12-2025, Remark column is compulsory for amount type
                if(this.selections.remark == null || this.selections.remark == '' || this.selections.remark == undefined){
                    this.isErr = true;
                    this.errMsg = "Please fill in remark column";
                    this.$emit('error', {isErr: this.isErr, errMsg: this.errMsg});
                    return;
                }
            }
        
            this.isErr = false;
            if (!this.isExisting && !this.modify) {
                this.selections.id = null;

                this.detailItem.push(Object.assign({}, this.selections));

            } else {
                if(!this.modify){
                    this.selections.action = 2;
                }
                if (this.compareArray(this.detailItem, this.selections)) {
                    console.log(this.compareArray(this.detailItem, this.selections))
                }
                
            }
            // console.log('detailitem', this.detailItem)
            this.$emit('input', this.detailItem);
            this.periodicdialog = false;
            

            // reset the form fields
            this.closeDetail();
        },

        closeDetail() {
            this.periodicdialog = false;
            this.isErr = false;
            this.isExisting = false;
            this.modify = false;

            // reset the form fields
            this.resetSelections();
        },

        resetSelections() {
            this.selections = {
                id: null,

                //colid: null,
                col: null,
                coldesc: null,
                replacement: null,
                remark: null,
                
                rectimestamp: null,
                updatedby: null,
                action:0 ,
                stamp: 0,
            }
            this.columnType = 1;// Reset to default 1,which is details
        },

    },

    async mounted() {
        await this.loadEAaddOnList();
        await this.loadCompany();
        await this.loadBranch();
        await this.changecolumntype(this.columnType);// Filter in the F01 to F23 first
    }
}
</script>   